






















































import { Vue, Component, Watch } from "vue-property-decorator";
import FileManager from "@/components/files/FileManager.vue";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import { Employee as IEmployee } from "@/api/models/employee";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import { getCurrentCompanyId } from "@/plugins/roles";
import categories, { CategoriesListParams } from "@/getinfo-api/categories";
import { Category as ICategory } from "@/api/models/category";
import { isRoot } from "@/plugins/roles";
import { envVars } from "@/plugins/env-vars";

@Component({
  components: { FileManager }
})
export default class ImportCourseView extends Vue {
  employees: Array<IEmployee> = [];
  materialOwner!: string | undefined;
  categories: Array<ICategory> = [];
  selectedCategory!: string | undefined;

  data() {
    return {
      materialOwner: undefined,
      selectedCategory: undefined
    };
  }

  get root(): boolean {
    return isRoot();
  }

  get companyId(): string {
    return getCurrentCompanyId();
  }

  get result(): string {
    return `./import.js --login=admin --password=123 --path=${envVars.getStr(
      "VUE_APP_API_HOST"
    )}
    --companyId=${this.companyId} --materialOwner=${
      this.materialOwner
    } --categoryId=${this.selectedCategory}`;
  }

  async getAllCategories() {
    let params: CategoriesListParams = {
      companyId: this.companyId,
      limit: 1000
    };
    const response = await categories(params);
    this.categories = [...response.data.items];
    this.selectedCategory = this.categories ? this.categories[0].id : undefined;
  }

  @Watch("companyId", { immediate: true })
  getAllContentManagers() {
    this.employees = [];
    this.materialOwner = undefined;
    let params: EmployeeListParams = {
      id: this.companyId,
      limit: 100,
      roles: ["content_manager"]
    };
    employee(params).then((res: { data: IEmployeesList2 }) => {
      this.employees = [...this.employees, ...res.data.employees];
      this.materialOwner = res.data.employees[0]?.user?.id;
    });
  }

  created() {
    if (this.root) {
      this.getAllCategories();
    } else {
      this.$router.push({ name: "error" });
    }
  }
}
